// extracted by mini-css-extract-plugin
export default {"inner":"FaqPage_inner__0xV+R","list":"FaqPage_list__m41V2","item":"FaqPage_item__+Lsej"};